import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Phone, FileSpreadsheet, Calendar, Share2, X } from 'lucide-react';
interface FrankensteinSlideProps {
  content: {
    headline: string;
    bullets: string[];
  };
}
export function FrankensteinSlide({
  content
}: FrankensteinSlideProps) {
  const icons = [{
    icon: Phone,
    color: 'text-blue-500',
    bg: 'bg-blue-100'
  }, {
    icon: FileSpreadsheet,
    color: 'text-green-600',
    bg: 'bg-green-100'
  }, {
    icon: Calendar,
    color: 'text-purple-500',
    bg: 'bg-purple-100'
  }, {
    icon: Share2,
    color: 'text-pink-500',
    bg: 'bg-pink-100'
  }];
  return <div className="bg-[#1C1C1C] rounded-2xl p-16 min-h-[600px] flex flex-col justify-center" data-id="element-130">
      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl md:text-5xl font-bold text-[#F5F5F5] mb-16 text-center max-w-4xl mx-auto leading-tight" data-id="element-131">
        {content.headline}
      </motion.h2>

      <div className="flex flex-col md:flex-row gap-16 items-center justify-center" data-id="element-132">
        {/* Visual Area */}
        <div className="w-full md:w-1/2 relative h-64 flex items-center justify-center" data-id="element-133">
          {icons.map((item, index) => {
          const Icon = item.icon;
          // Calculate circular positions
          const angle = index * (360 / icons.length) * (Math.PI / 180);
          const radius = 100;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          return <Fragment key={index} data-id="element-134">
                <motion.div initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: 0.2 + index * 0.1,
              type: 'spring'
            }} className={`absolute w-20 h-20 rounded-2xl ${item.bg} flex items-center justify-center shadow-lg`} style={{
              transform: `translate(${x}px, ${y}px)`
            }} data-id="element-135">
                  <Icon className={`w-10 h-10 ${item.color}`} data-id="element-136" />
                </motion.div>

                {/* Red X between nodes */}
                <motion.div initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: 0.8 + index * 0.1
            }} className="absolute text-red-500" style={{
              transform: `translate(${x * 0.5}px, ${y * 0.5}px)`
            }} data-id="element-137">
                  <X className="w-8 h-8" strokeWidth={3} data-id="element-138" />
                </motion.div>
              </Fragment>;
        })}

          {/* Center Chaos Icon */}
          <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 1.2
        }} className="absolute w-16 h-16 bg-red-500 rounded-full flex items-center justify-center shadow-red-500/50 shadow-lg z-10" data-id="element-139">
            <X className="w-10 h-10 text-white" strokeWidth={4} data-id="element-140" />
          </motion.div>
        </div>

        {/* Bullets Area */}
        <div className="w-full md:w-1/2 space-y-6" data-id="element-141">
          {content.bullets.map((bullet, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4 + index * 0.15
        }} className="flex items-start gap-4 bg-[#4D4D4D]/20 p-5 rounded-xl border border-[#4D4D4D]/40" data-id="element-142">
              <div className="w-2 h-2 rounded-full bg-red-500 mt-2.5 flex-shrink-0" data-id="element-143" />
              <p className="text-xl text-[#F5F5F5] leading-relaxed" data-id="element-144">{bullet}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}
export default FrankensteinSlide;